<template>
  <news />
</template>
